// extracted by mini-css-extract-plugin
export default {"wrapper":"error-boundary_wrapper__sWRLD","title":"error-boundary_title__iwnhg"};